import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ENVIRONMENT } from '@cfp/core';
import { BuildingDetailsHeader } from '@cfp/features-shared/building';
import { TranslateModule } from '@ngx-translate/core';
import { BuildingDetailsDTO } from 'csr-asset-app';
import { ReportCoverPage } from '../../portfolio-report/report-cover-page';
import { BuildingReportFooter } from '../components';

@Component({
  selector: 'cfp-building-report-cover',
  templateUrl: './building-report-cover.html',
  styleUrls: ['./building-report-cover.scss'],
  imports: [BuildingDetailsHeader, BuildingReportFooter, ReportCoverPage, TranslateModule, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingReportCover {
  protected readonly environment = inject(ENVIRONMENT);

  public readonly building = input.required<BuildingDetailsDTO>();
  public readonly hideSelect = input<boolean>(false);
  public readonly hideGoToAllBuildings = input<boolean>(false);
  public readonly hideDeleteBuilding = input<boolean>(false);
  public readonly canDownloadReport = input<boolean>(false);
  public readonly showFooterLogo = input<boolean>(true);
  public readonly showAppName = input<boolean>(this.environment.showTitle);
  public readonly showGradientCover = input<boolean>(false);
  public readonly reportCoverTitle = input<string>('');

  protected readonly currentDate = new Date();
}
